export class RRGarment {
  id: string;
  isTryonable: boolean;
  imageUrl: string;
  highResImageUrl: string;
  title: string;
  retailerName: string;
  price: {
    value: number;
    currency: string;
    displayString: string;
  };
  aspectRatio: number;
  isShopable: boolean;
  base64Thumbnail: string;
  garmentGroup: number;
  fileUrl;

  static generateThumbnailUrl(imageUrl: string): string {
    const dotIndex = imageUrl.lastIndexOf('.');
    const url = imageUrl.substring(0, dotIndex) + '@3x.jpg';
    return url;
  }
}
